import React, { useState } from 'react';
import BCI from '../../../Assets/images/BrowsCategoryIcon.png';
import BDI from '../../../Assets/images/BDI.png';
import BDisI from '../../../Assets/images/BDisI.png';
import TDI from '../../../Assets/images/TDI.png';
import BSI from '../../../Assets/images/BSI.png';
import MyFavorite from './MyFavorite';
import Categories from '../../../Modals/FilterBrowsesInDashboard/Categories';
import Department from '../../../Modals/FilterBrowsesInDashboard/Department';
import Districts from './../../../Modals/FilterBrowsesInDashboard/Districts';
import Upazila from '../../../Modals/FilterBrowsesInDashboard/Upazila';
import Sources from '../../../Modals/FilterBrowsesInDashboard/Sources';
const BrowsesInMyFavorite = () => {
  const [searchInput, setSearchInput] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [modals, setModals] = useState({
    category: false,
    department: false,
    district: false,
    upazila: false,
    sources: false,
  });

  const [selected, setSelected] = useState({
    category: null,
    department: null,
    district: null,
    upazila: null,
    sources: null,
  });

  const toggleModal = (type, isOpen) => {
    setModals(prev => ({ ...prev, [type]: isOpen }));
  };

  const handleSelect = (type, value) => {
    setSelected(prev => ({ ...prev, [type]: value }));
    toggleModal(type, false);
  };

    const renderButton = (type, label, icon, selectedValue, onClick) => (
      <div className="relative inline-flex flex-col items-center md:w-[200px] w-[280px]">
        <button
          onClick={onClick}
          className="text-blue-500 border text-nowrap border-blue-400 px-4 pt-4 pb-1 rounded-md  text-start text-sm font-semibold w-full shadow-md"
        >
          {selectedValue || `Select ${label}`}
        </button>

        <button
          onClick={onClick}
          className="absolute top-0 left-1 -translate-y-1/2 bg-slate-50 text-blue-500 border border-blue-400 px-3 py-1 rounded-md flex items-center gap-x-2 shadow-sm"
        >
          <img src={icon} alt={`Browse by ${label}`} className="w-4 h-4" />
          <span className="text-xs text-nowrap font-medium">{`Browse by ${label}`}</span>
        </button>
      </div>
    );
  
  // const renderButton = (type, label, icon, selectedValue, onClick) => (
  //   <button
  //     className="relative bg-white text-blue-500 border border-gray-300 px-2 py-2 rounded-t-md mb-0 flex items-center gap-1"
  //     onClick={onClick}
  //   >
  //     <img src={icon} alt={`Browse by ${label}`} className="w-4 h-4" />
  //     <span className="text-xs">Browse by {label}</span>
  //     <button className="absolute left-1/2 transform -translate-x-1/2 mt-14 text-blue-500 bg-white border border-gray-300 w-48 py-1 rounded-md text-xs">
  //       {selectedValue || `Select ${label}`}
  //     </button>
  //   </button>
  // );

  // Triggered when the "Search" button is clicked

  const handleSearchClick = () => {
    setSearchQuery(searchInput); // Set searchQuery to finalize the input for search
  };

  // Triggered on every keystroke in the input field
  const handleSearchChange = e => {
    const inputValue = e.target.value.toLowerCase();
    setSearchInput(inputValue);
    setSearchQuery(inputValue); // Trigger real-time search
  };

  return (
    <div className="md:mt-36 mt-36">
      <h1 className="text-blue-800 md:text-xl text-lg text-center font-bold py-3 bg-orange-100">
        My Wishlist
      </h1>
      <div>
        <div className="px-2 w-full bg-white md:py-6 py-4">
          <div className="flex flex-wrap justify-center md:gap-16 gap-8 md:mt-4 mt-7 text-xs">
            {renderButton(
              'category',
              'Categories',
              BCI,
              selected.category,
              () => toggleModal('category', true)
            )}
            {renderButton(
              'department',
              'Department',
              BDI,
              selected.department,
              () => toggleModal('department', true)
            )}
            {renderButton(
              'district',
              'District',
              BDisI,
              selected.district,
              () => toggleModal('district', true)
            )}
            {renderButton('upazila', 'Upazila', BDisI, selected.upazila, () =>
              toggleModal('upazila', true)
            )}
            {renderButton('sources', 'sources', BSI, selected.sources, () =>
              toggleModal('sources', true)
            )}
            {/* {renderButton(
            'tenderDeadline',
            'Deadline',
            TDI,
            selected.tenderDeadline,
            () => toggleModal('tenderDeadline', true)
          )} */}
          </div>

          {modals.category && (
            <ModalWrapper onClose={() => toggleModal('category', false)}>
              <Categories
                handleCategorySelect={value => handleSelect('category', value)}
              />
            </ModalWrapper>
          )}
          {modals.department && (
            <ModalWrapper onClose={() => toggleModal('department', false)}>
              <Department
                handleDepartmentSelect={value =>
                  handleSelect('department', value)
                }
              />
            </ModalWrapper>
          )}

          {modals.district && (
            <ModalWrapper onClose={() => toggleModal('district', false)}>
              <Districts
                handleDistrictSelect={value => handleSelect('district', value)}
              />
            </ModalWrapper>
          )}

          {modals.upazila && (
            <ModalWrapper onClose={() => toggleModal('upazila', false)}>
              <Upazila
                handleUpazilaSelect={value => handleSelect('upazila', value)}
              />
            </ModalWrapper>
          )}
          {modals.sources && (
            <ModalWrapper onClose={() => toggleModal('sources', false)}>
              <Sources
                handleSourcesSelect={value => handleSelect('sources', value)}
              />
            </ModalWrapper>
          )}
          {/* {modals.tenderDeadline && (
          <ModalWrapper onClose={() => toggleModal('tenderDeadline', false)}>
            <TenderDeadline
              handleTenderDeadlineSelect={value =>
                handleSelect('tenderDeadline', value)
              }
            />
          </ModalWrapper>
        )} */}

          {/* Section 2: Filter with Search */}
          <div className="md:mt-14 mt-12 mb-2 md:px-6 px-2 flex justify-center items-center md:text-lg text-xs ">
            <input
              type="text"
              placeholder="Search tenders number or keyword..."
              className="md:p-2 p-1.5 w-72 md:w-full rounded-l-lg border-2 border-gray-300 focus:outline-none"
              value={searchInput}
              onChange={handleSearchChange} // Handle real-time search
              // onChange={e => setSearchQuery(e.target.value)} Handle only real-time search
              // onChange={e => setSearchInput(e.target.value)}
            />
            <button
              onClick={handleSearchClick} // Handle button click search
              className="bg-blue-500 text-white md:px-4 md:py-2.5 py-2 w-20 rounded-r-lg sm:w-auto mt-0 sm:mt-0"
            >
              Search
            </button>
          </div>
        </div>
        <div className="md:px-7 px-0 mt-6">
          <MyFavorite
            searchQuery={searchQuery}
            selectedCategory={selected.category}
            selectedDepartment={selected.department}
            selectedDistrict={selected.district}
            selectedUpazila={selected.upazila}
            selectedSource={selected.sources}
          />
        </div>
      </div>
    </div>
  );
};

const ModalWrapper = ({ children, onClose }) => (
  <div className="fixed inset-0 z-50 flex justify-center">
    <div
      className="absolute inset-0 bg-black opacity-50"
      onClick={onClose}
    ></div>
    <div className="absolute bg-BrowsBg shadow-lg md:p-6 p-2 md:w-11/12 w-full overflow-y-auto md:h-[580px] 2xl:h-[880px] top-10 rounded-sm">
      <button
        className="absolute md:top-4 top-2 md:right-6 right-4 text-black hover:text-red-500 md:text-xl text-sm md:font-bold font-semibold"
        onClick={onClose}
      >
        &#x2715;
      </button>
      {children}
    </div>
  </div>
);

export default BrowsesInMyFavorite;
